import axiosInstance from '@/lib/axios';
import {
  ReminderItem,
  CreateReminderPayload,
  UpdateReminderPayload,
  ListRemindersParams,
  ListRemindersResponse,
  ListReminderLogsResponse,
  ReminderStatsSummary,
} from '../types/reminder.types';

const BASE = 'reminders';

export const listReminders = (
  chatBotId: string,
  params?: ListRemindersParams
): Promise<ListRemindersResponse> =>
  axiosInstance
    .get(`${BASE}/chatbot/${chatBotId}`, { params })
    .then((r) => r.data.data);

export const getReminderStats = (chatBotId: string): Promise<ReminderStatsSummary> =>
  axiosInstance.get(`${BASE}/chatbot/${chatBotId}/stats`).then((r) => r.data.data);

export const createReminder = (
  chatBotId: string,
  payload: CreateReminderPayload
): Promise<ReminderItem> =>
  axiosInstance.post(`${BASE}/chatbot/${chatBotId}`, payload).then((r) => r.data.data);

export const getReminderById = (
  chatBotId: string,
  reminderId: string
): Promise<ReminderItem> =>
  axiosInstance.get(`${BASE}/${chatBotId}/${reminderId}`).then((r) => r.data.data);

export const updateReminder = (
  chatBotId: string,
  reminderId: string,
  payload: UpdateReminderPayload
): Promise<ReminderItem> =>
  axiosInstance.put(`${BASE}/${chatBotId}/${reminderId}`, payload).then((r) => r.data.data);

export const deleteReminder = (
  chatBotId: string,
  reminderId: string
): Promise<void> =>
  axiosInstance.delete(`${BASE}/${chatBotId}/${reminderId}`).then((r) => r.data.data);

export const pauseReminder = (
  chatBotId: string,
  reminderId: string
): Promise<ReminderItem> =>
  axiosInstance.post(`${BASE}/${chatBotId}/${reminderId}/pause`).then((r) => r.data.data);

export const resumeReminder = (
  chatBotId: string,
  reminderId: string
): Promise<ReminderItem> =>
  axiosInstance.post(`${BASE}/${chatBotId}/${reminderId}/resume`).then((r) => r.data.data);

export const listReminderLogs = (
  reminderId: string,
  params?: { page?: number; limit?: number; status?: string; search?: string }
): Promise<ListReminderLogsResponse> =>
  axiosInstance.get(`${BASE}/logs/${reminderId}`, { params }).then((r) => r.data.data);

export const retryFailedRecipients = (
  chatBotId: string,
  reminderId: string
): Promise<{ retriedCount: number; message: string }> =>
  axiosInstance
    .post(`${BASE}/${chatBotId}/${reminderId}/retry-failed`)
    .then((r) => r.data.data);
